import request from '@/utils/request'

const api = decodeURIComponent(window.atob(process.env.VUE_APP_BASE_EXTERNAL_NETWORK_API))
// 投诉表单保存
export function saveComplaint(data) {
  return request({
    url: api + '/cnooc/complaint/saveComplaint',
    method: 'post',
    headers: {'isToken': false},
    data
  })
}

// 投诉表单获取分页
export function getComplaint(params) {
  return request({
    url: api + '/cnooc/complaint/getComplaint',
    method: 'get',
    headers: {'isToken': false},
    params
  })
}


// 投诉表单获取分页
export function getComplaintInfor(id){
  return request({
    url: api + '/cnooc/complaint/getComplaintInfor',
    method: 'get',
    headers: {'isToken': false},
    params: { id }
  })
}


// 获取验证码
export function getCodeImg() {
  return request({
    url: api + '/getPic',
    headers: {'isToken': false},
    method: 'get'
  })
}
